import { memo } from 'react';

import { ImportManager } from '~/components/Import/ImportManager';
import { PrivateUploadManager } from '~/components/Upload/PrivateUploadManager';
import { useWorkspaceActivityStore } from '~/components/v2/store/features/workspace/useWorkspaceActivityStore';
import { WorkspaceActivityContainer } from '~/components/WorkspaceActivityContainer';
import { WORKSPACE_UPLOADS_ACTIVITY_CONTAINER_CORNER } from '~/constants/localStorageKeys';
import { WORKSPACE_UPLOADS_ACTIVITY_CONTENT_ID } from '~/constants/workspaceActivity';

export const PrivateUploadsActivityContainer = memo(() => {
  const open = useWorkspaceActivityStore((state) => state.open);

  return (
    <WorkspaceActivityContainer
      contentId={WORKSPACE_UPLOADS_ACTIVITY_CONTENT_ID}
      storageKey={WORKSPACE_UPLOADS_ACTIVITY_CONTAINER_CORNER}
      visible={open}
    >
      <PrivateUploadManager />
      <ImportManager />
    </WorkspaceActivityContainer>
  );
});

PrivateUploadsActivityContainer.displayName = 'PrivateUploadsActivityContainer';
